import styled from "styled-components";

export const Main = styled.div`
  width: 150px;
  padding: 0;
`;

export const Styled = styled.div`
  width: 440px;
  display: flex;
  flex-direction: column;
  gap: 10px;

  .authSelect {
    margin-bottom: 2px;
  }

  .row {
    display: flex;
    gap: 10px;
    align-items: center;
  }

  .row > * {
    flex: 1;
  }

  .muted {
    color: #6b7280;
    font-size: 13px;
    margin: 6px 0 0 0;
    line-height: 1.45;
  }

  .card {
    border: 1px solid #e5e7eb;
    border-radius: 12px;
    padding: 12px;
    background: #f8fafc;
  }

  .cardHeader {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    margin-bottom: 8px;
  }

  .cardHeader h4 {
    margin: 0;
    font-size: 14px;
    font-weight: 600;
    color: #111827;
  }

  .connectionMeta {
    margin: 0;
  }

  .badge {
    font-size: 12px;
    padding: 4px 8px;
    border-radius: 999px;
    border: 1px solid #e5e7eb;
    background: #fff;
    color: #374151;
    white-space: nowrap;
  }

  .badge.connected {
    border-color: #10b98155;
    background: #10b98115;
    color: #065f46;
  }

  .badge.disconnected {
    border-color: #f59e0b55;
    background: #f59e0b15;
    color: #92400e;
  }

  .badge.renewing {
    border-color: #3b82f655;
    background: #3b82f615;
    color: #1e3a8a;
  }

  .badge.error {
    border-color: #ef444455;
    background: #ef444415;
    color: #991b1b;
  }

  .monoBox {
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    padding: 8px;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    cursor: pointer;
  }

  .monoValue {
    font-family: "Monaco", "Menlo", "Ubuntu Mono", monospace;
    font-size: 13px;
    color: #111827;
    word-break: break-all;
    overflow-wrap: anywhere;
    flex: 1;
    min-width: 0;
  }

  .copyIcon {
    color: #6b7280;
    font-size: 12px;
    flex-shrink: 0;
  }

  .copyIcon.copied {
    color: #323432;
  }

  .folderList .btn1.active {
    background: #323432;
    color: #fff;
    border-color: #323432;
  }

  .buttons {
    display: flex;
    gap: 8px;
  }

  .buttons button {
    flex: 1;
  }

  .statusText {
    margin-top: 8px;
    font-size: 13px;
    line-height: 1.3;
    white-space: pre-wrap;
    word-break: break-word;
  }

  .statusText.error {
    color: #b91c1c;
  }

  .statusText.success {
    color: #065f46;
  }

  .filterSummary {
    margin: 4px 0 0 0;
    line-height: 1.5;
  }

  .secretRow {
    display: flex;
    gap: 10px;
    align-items: center;
    margin-top: 10px;
  }

  .secretRow label {
    width: 90px;
    font-weight: 400;
    white-space: nowrap;
    font-size: 15px;
  }

  .secretInputWrap {
    position: relative;
    flex: 1;
  }

  .secretInput {
    width: 100%;
    height: 40px;
    border-radius: 10px;
    border: 1px solid #e5e7eb;
    background-color: #f9fafb;
    padding: 0 44px 0 10px;
    outline: none;
    font-family: monospace;
    font-size: 14px;
    color: #111827;
  }

  .toggleSecret {
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    border: none;
    background: transparent;
    cursor: pointer;
    color: #6b7280;
    font-size: 12px;
    padding: 4px 6px;
  }
  .switch {
    margin-bottom: 0;
  }
  .btn1 {
    height: 35px;
  }
  .scroll {
    overflow: auto;
    max-height: 300px;
    padding-right: 4px;
  }

  .folderList {
    margin-top: 10px;
    background: #f3f4f6;
    border-radius: 12px;
    padding: 10px;
    border: 1px solid #e5e7eb;
  }

  .folderHeader {
    margin-bottom: 8px;
  }

  .folderRows {
    max-height: 230px;
    overflow: auto;
    display: grid;
    gap: 8px;
  }

  .folderRow {
    display: grid;
    grid-template-columns: 1fr auto;
    gap: 8px;
    align-items: center;
    padding: 10px;
    border-radius: 10px;
    background: #fff;
    border: 1px solid #e5e7eb;
  }

  .folderInfo {
    min-width: 0;
  }

  .folderName {
    font-weight: 600;
    color: #111827;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .folderMeta {
    margin-top: 4px;
    font-size: 12px;
    word-break: break-all;
  }

  .folderActions {
    display: flex;
    gap: 6px;
    justify-content: flex-end;
  }
`;

export const Loader = styled.span`
  width: 68px;
  height: 68px;
  border: 5px solid #9ca3af;
  border-bottom-color: transparent;
  border-radius: 50%;
  display: block;
  box-sizing: border-box;
  animation: rotation 1s linear infinite;
  margin: 0 auto;

  @keyframes rotation {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;
